import { Component, ElementRef, ViewChild, AfterViewInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { AdaptiveCardSubmitData } from '@app/model/adaptive-card-submit-data';
import * as AdaptiveCards from 'adaptivecards';

@Component({
    selector: 'app-chat-adaptive-card',
    templateUrl: './chat-adaptive-card.component.html',
    styleUrls: ['./chat-adaptive-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChatAdaptiveCardComponent implements AfterViewInit {
  @Input() adaptiveCard: Partial<AdaptiveCards.AdaptiveCard>

  @Output() submitAction = new EventEmitter<AdaptiveCardSubmitData>;

  @ViewChild('cardContainer') cardContainer!: ElementRef;

  public ngAfterViewInit(): void {
    const adaptiveCard = new AdaptiveCards.AdaptiveCard();

    adaptiveCard.onExecuteAction = (action) => {
      if (action instanceof AdaptiveCards.SubmitAction) {
        const textKey = Object.keys(action.data).find(key => key !== 'actionSubmitId');
        const text = textKey ? action?.data?.[textKey] : '';

        const normalized = {
          text,
          value: action.data
        };

        this.submitAction.emit(normalized);
      }
    };

    adaptiveCard.hostConfig = new AdaptiveCards.HostConfig({
      containerStyles: {
        default: {
          backgroundColor: "#FAFAFA",
          foregroundColors: {
            default: { default: "#222224", subtle: "#4E4E51" },
            accent: { default: "#4075FF", subtle: "#4075FF" },
            attention: { default: "#CC423D", subtle: "#CC423D" },
            good: { default: "#2BD965", subtle: "#167844" },
            warning: { default: "#5C471F", subtle: "#5C471F" }
          }
        }
      }
    });

    adaptiveCard.parse(this.adaptiveCard);
    const renderedElement = adaptiveCard.render();

    if (renderedElement) {
      this.cardContainer.nativeElement.appendChild(renderedElement);
    }
  }
}